import { Platform } from "react-native";
var PLATFORM = Platform.OS;
export {
  PLATFORM
};
//# sourceMappingURL=platform.js.map
